const initialState = {
    isLoading: true,
    data: [],
    error: false,
};

// Error data is not stored in this reducer
const futureOffers = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case 'FUTURE_OFFERS_REQUEST_START':
            return {
                ...state,
                isLoading: true,
            };
        case 'FUTURE_OFFERS_REQUEST_SUCCESS':
            return {
                isLoading: false,
                data: action.payload,
                error: false,
            };
        case 'FUTURE_OFFERS_REQUEST_FAILURE':
            return {
                ...state,
                isLoading: false,
                error: true,
            };
        default:
            return state;
    }
};

export default futureOffers;
